import React, { useState, useEffect } from "react";
import {
  defineBlock,
  smartProps,
  useInspectorControl,
  useSmartProp,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import apiFetch from "@wordpress/api-fetch";
import Masonry from "react-masonry-css";
import ArticleGrid from "../articles-grid/block";
import { CommonLoading } from "react-loadingg";
import { ReactComponent as Check } from "../assets/check_grey.svg";
import arrowPlain from "../assets/arrow-plain-simple-right.svg";
import EditableText from "../shared/editable-text";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import { useTranslation } from "react-i18next";

function Filter({ name, state, onClick, index }) {
  return (
    <div
      onClick={() => onClick(index)}
      className={state ? style.filterOn : style.filter}
    >
      {name} <Check />
    </div>
  );
}

function Inspector() {
  const [homeText, setHomeText] = useSmartProp("homeText");
  const [actuText, setActuText] = useSmartProp("actuText");
  return (
    <>
      <PanelBody title="Configuration fil d'ariane" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Titre accueil"}
            value={homeText}
            onChange={(value) => setHomeText(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Titre Actualité"}
            value={actuText}
            onChange={(value) => setActuText(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ homeText, actuText }) {
  useInspectorControl(Inspector);
  const [news, setNews] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [endReached, setEndReached] = useState(false);
  const [categories, setCategories] = useState(null);
  const breakpointColumnsObj = {
    default: 4,
    1100: 2,
    600: 1,
  };
  const numberPerLoad = 20;
  const { t, i18n } = useTranslation();
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  function handleScroll() {
    if (
      window.innerHeight + document.documentElement.scrollTop !==
      document.documentElement.offsetHeight
    )
      return;
    setPage((page) => page + 1);
  }
  useEffect(() => {
    apiFetch({
      path: `wp/v2/categories?_fields=id,name,slug&hide_empty=1&lang=${i18n.language}`,
    }).then((category) => {
      let cat = [];
      category.forEach((element) => {
        let tab = [];
        tab["slug"] = element.slug;
        tab["name"] = element.name;
        tab["state"] = true;
        cat.push(tab);
      });
      setCategories(cat);
    });
  }, [setCategories, i18n.language]);
  useEffect(() => {
    if (!endReached && categories) {
      let tab = [];
      categories.forEach((element) => {
        if (element.state) {
          tab.push(element.slug);
        }
      });
      setLoading(true);
      apiFetch({
        path: `smartfire/news?limit=${numberPerLoad}&paged=${page}&category=${tab.join()}&lang=${
          i18n.language
        }`,
      }).then((news) => {
        setNews((old_news) =>
          old_news && news ? [...old_news, ...news] : news
        );
        if (news && news.length < numberPerLoad) {
          setEndReached(true);
        }
        setLoading(false);
      });
    }
  }, [
    endReached,
    setLoading,
    numberPerLoad,
    page,
    setNews,
    categories,
    i18n.language,
  ]);
  const toogleFilter = (index) => {
    if (
      categories.filter((e) => e.state).length > 1 ||
      !categories[index].state
    ) {
      let newCategories = [...categories];
      newCategories[index].state = !categories[index].state;
      setPage(1);
      setEndReached(false);
      setNews(null);
      setCategories(newCategories);
    }
  };
  return (
    <div className={style.block}>
      <div className={style.header}>
        <div className="arianeBlock">
          <div className="sf-ariane">
            <a
              className="ariane-home"
              href={i18n.language === "fr" ? "/" : "/?lang=en"}
            >
              {homeText}
            </a>
            <img src={arrowPlain} alt="Arrow" />
            <span className="ariane-name">{actuText}</span>
          </div>
        </div>
        <EditableText
          className={style.title}
          placeholder={"Entrez un titre"}
          smartProp="title"
          tagName="h1"
        />
        <EditableText
          className={style.filterText}
          placeholder={"Entrez un titre pour le filtrage"}
          smartProp="filtertext"
        />
        <div className={style.filterBlock}>
          {categories &&
            categories.map((category, index) => (
              <Filter
                index={index}
                onClick={toogleFilter}
                key={index}
                name={category.name}
                state={category.state}
              />
            ))}
        </div>
      </div>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className={style.mansonry}
        columnClassName={style.col}
      >
        {news &&
          news.map((actu, index) => (
            <ArticleGrid
              key={index}
              height={index % 2 ? "400px" : "450px"}
              category={actu.category}
              image={actu.image}
              url={actu.url}
              title={actu.title}
              extract={actu.extract}
              fade={true}
              readMore={t("Lire la suite")}
            />
          ))}
      </Masonry>
      {loading && (
        <CommonLoading
          style={{ position: "relative", margin: "30px auto", height: "30px" }}
          size="small"
          color={style.blue}
        />
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault("L’actualité du groupe SPI"),
    filtertext: smartProps.string.withDefault("Filtrer"),
    homeText: smartProps.string.withDefault("Accueil"),
    actuText: smartProps.string.withDefault("Actualités"),
  },
  setup: {
    title: "Mansonry News",
  },
});
